import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
import buildInfo from './environments/build-info.generated.json'
import * as Sentry from '@sentry/angular'

declare global {
  interface Window {
    _depoto: any
    getAppVersion: () => string[]
  }
}

function getSentryEnvironment(): string | undefined {
  switch (window.location.hostname) {
    case 'app.depoto.cz':
      return 'production'
    case 'app.depoto.cz.tomatomstage.cz':
      return 'stage'
    case 'localhost':
      // note: change this to 'local' to temporarily enable Sentry on local dev in case of need
      return undefined
    default:
      return undefined
  }
}

const sentryEnvironment = getSentryEnvironment()
const isSentryEnabled = Boolean(environment.sentryDsn && sentryEnvironment)

Sentry.init({
  dsn: environment.sentryDsn,
  environment: sentryEnvironment ?? environment.sentryEnv,
  enabled: isSentryEnabled,
  release: `depoto-client-v2@${buildInfo.version}+${buildInfo.commitShortHash}`,
  integrations: [Sentry.browserTracingIntegration()],
  tracePropagationTargets: [environment.urlDeployment],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
})

if (environment.production) {
  enableProdMode()
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err))
